export default "__VITE_ASSET__CSShfgp0__"